import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  // Paper,
  // TextField,
  // InputAdornment,
  IconButton,
  Tooltip,
  Chip,
  Stack,
  // Container,
  Snackbar,
  Alert,
  Button,
  // FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  Grid,
  Card,
  CardContent,
  CircularProgress,
} from '@mui/material';

import {
  // Search as SearchIcon,
  // Clear as ClearIcon,
  MenuOpen as MenuOpenIcon,
  // Visibility as VisibilityIcon,
  Chat as ChatIcon,
  Refresh as RefreshIcon,
  SupportAgent as SupportAgentIcon,
  SmartToy as SmartToyIcon,
  Assessment as AssessmentIcon,
  Block as BlockIcon,
  CheckCircle as CheckCircleIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';

// import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import apiService from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import ChatMessagesModal from '../components/ChatMessagesModal';

// Пока не будем создавать отдельную страницу для деталей, 
// можно будет добавить позже или отображать в модальном окне.

const AdminChatHistoryPage = () => {
  const [chatSessions, setChatSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [page, setPage] = useState(0);
  // const [pageSize, setPageSize] = useState(10);
  // const [totalRows, setTotalRows] = useState(0);
  // const [searchTerm, setSearchTerm] = useState('');
  // const [statusFilter, setStatusFilter] = useState('');

  // Статистика
  const [stats, setStats] = useState(null);

  // Модальные окна
  const [chatModalOpen, setChatModalOpen] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);

  // Уведомления
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const { canEdit } = useAuth();

  // Данные текущего админа (можно получить из контекста или localStorage)
  const [currentAdmin] = useState(() => {
    try {
      const adminData = localStorage.getItem('adminUser');
      return adminData ? JSON.parse(adminData) : null;
    } catch {
      return null;
    }
  });

  const fetchChatSessions = useCallback(async () => {
    setLoading(true);
    try {
      // const response = await apiService.adminChatHistory.getChatSessions(
      //   page + 1,
      //   pageSize,
      //   searchTerm,
      //   statusFilter
      // );

      const response = await apiService.adminChatHistory.getChatSessions(1, 0);

      if (response.data.success) {
        setChatSessions(response.data.data.sessions.map(s => ({
          ...s,
          id: s._id
        })));
        // setTotalRows(response.data.data.total);
      } else {
        setSnackbar({
          open: true,
          message: response.data.message || 'Не удалось загрузить историю чатов',
          severity: 'error'
        });
      }
    } catch (error) {
      console.error('[AdminChatHistory] Ошибка загрузки сессий:', error);
      setSnackbar({
        open: true,
        message: 'Произошла ошибка при загрузке истории чатов',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchStats = useCallback(async () => {
    try {
      const response = await apiService.adminChatHistory.getChatStats();
      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('[AdminChatHistory] Ошибка загрузки статистики:', error);
    }
  }, []);

  useEffect(() => {
    fetchChatSessions();
    fetchStats();
  }, [fetchChatSessions, fetchStats]);

  // const handleSearchChange = (event) => {
  //   setSearchTerm(event.target.value);
  // };

  // const handleStatusFilterChange = (event) => {
  //   setStatusFilter(event.target.value);
  // };

  // const handleSearchSubmit = () => {
  //   setPage(0);
  //   fetchChatSessions();
  // };

  // const handleClearSearch = () => {
  //   setSearchTerm('');
  //   setStatusFilter('');
  //   setPage(0);
  // };

  const handleViewChat = (session) => {
    console.log(session)
    setSelectedSession(session);
    setChatModalOpen(true);
  };

  const handleTakeChat = async (sessionId, userId) => {
    try {
      const response = await apiService.adminChatHistory.takeChat({
        sessionId,
        userId
      });

      if (response.data.success) {
        setSnackbar({
          open: true,
          message: 'Чат взят на себя',
          severity: 'success'
        });

        // Обновляем список сессий
        fetchChatSessions();

        return response.data;
      } else {
        throw new Error(response.data.message || 'Ошибка взятия чата');
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || 'Ошибка взятия чата',
        severity: 'error'
      });
      throw error;
    }
  };

  const handleReleaseChat = async (sessionId, userId) => {
    try {
      const response = await apiService.adminChatHistory.releaseChat({
        sessionId,
        userId
      });

      if (response.data.success) {
        setSnackbar({
          open: true,
          message: 'Чат возвращён ИИ',
          severity: 'success'
        });

        // Обновляем список сессий
        fetchChatSessions();

        return response.data;
      } else {
        throw new Error(response.data.message || 'Ошибка возврата чата');
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || 'Ошибка возврата чата',
        severity: 'error'
      });
      throw error;
    }
  };

  const handleRefresh = () => {
    fetchChatSessions();
    fetchStats();
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'success';
      case 'waiting_operator':
        return 'warning';
      case 'with_operator':
        return 'info';
      case 'closed':
        return 'default';
      default:
        return 'default';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'active':
        return 'Активен';
      case 'waiting_operator':
        return 'Ждёт оператора';
      case 'with_operator':
        return 'С оператором';
      case 'closed':
        return 'Закрыт';
      default:
        return 'Неизвестен';
    }
  };

  // const getHandlerIcon = (handlerType) => {
  //   return handlerType === 'ai' ? <SmartToyIcon /> : <SupportAgentIcon />;
  // };

  const columns = [
    {
      name: "chat",
      label: "ЧАТ",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <Tooltip title="Просмотреть чат">
            <IconButton onClick={() => handleViewChat(value)} size="small" color="primary">
              <MenuOpenIcon />
            </IconButton>
          </Tooltip>
        )
      }
    },
    {
      name: "session",
      label: "Сессия",
      options: {
        filter: false,
        sort: true,
        // setCellProps: () => ({ style: { width: "10%" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="column" spacing={1}>
              <Chip
                color={value[1] === 'Нейросеть' ? 'success' : 'warning'}
                label={value[1]}
                size="small"
                variant="outlined"
              />
              <Chip
                color="info"
                label={value[0]}
                size="small"
                variant="outlined"
                onClick={() => {
                  navigator.clipboard.writeText(value[0]);
                  setSnackbar({
                    open: true,
                    message: `Скопировано: ${value[0]}`,
                    severity: 'success'
                  });
                }}
              />
            </Stack>
          );
        },
      }
    },
    {
      name: "user",
      label: "Пользователь",
      options: {
        filter: false,
        sort: true,
        // setCellProps: () => ({ style: { width: "25%" } }),
        customBodyRender: (value) => (
          <Stack direction="column" spacing={1}>
            <b style={{ textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis' }}>{value[0]}</b>
            <Chip
              color="info"
              label={value[1]}
              size="small"
              variant="outlined"
              onClick={() => {
                navigator.clipboard.writeText(value[1]);
                setSnackbar({
                  open: true,
                  message: `Скопировано: ${value[1]}`,
                  severity: 'success'
                });
              }}
            />
          </Stack>
        ),
        sortCompare: (order) => {
          return (a, b) => {
            return (a.data[0].localeCompare(b.data[0])) * (order === 'asc' ? 1 : -1);
          };
        }
      }
    },
    {
      name: "messages",
      label: "Сообщения",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <Stack direction="row" spacing={1}>
            <Stack direction="column" spacing={1}>
              <Chip
                color="info"
                label={"Всего: " + value[0]}
                size="small"
                variant="outlined"
              />
              <Chip
                color="info"
                label={"Пользователь: " + value[1]}
                size="small"
                variant="outlined"
              />
            </Stack>
            <Stack direction="column" spacing={1}>
              <Chip
                color="success"
                label={"Нейросеть: " + value[2]}
                size="small"
                variant="outlined"
              />
              <Chip
                color="warning"
                label={"Оператор: " + value[3]}
                size="small"
                variant="outlined"
              />
            </Stack>
          </Stack>

        ),
        sortCompare: (order) => {
          return (a, b) => {
            return (a.data[0] - b.data[0]) * (order === 'asc' ? 1 : -1);
          };
        }
      }
    },
    {
      name: "status",
      label: "Статус",
      options: {
        filter: true,
        sort: true,
        filterOptions: {
          names: ['Активен', 'Ждёт оператора', 'С оператором', 'Закрыт', 'Неизвестен']
        },
        customBodyRender: (value) => (
          <Stack direction="column" spacing={1}>
            <Chip
              icon={value[0] === 'Закрыт' ? <BlockIcon /> : <CheckCircleIcon />}
              color={value[1]}
              label={value[0]}
              size="small"
              variant="outlined"
            />
            <Chip
              color="info"
              label={value[2]}
              size="small"
              variant="outlined"
            />
          </Stack>
        ),
        sortCompare: (order) => {
          return (a, b) => {
            // return (new Date(b.data[2]) - new Date(a.data[2])) * (order === 'asc' ? 1 : -1);
            return (a.data[0].localeCompare(b.data[0])) * (order === 'asc' ? 1 : -1);
          };
        }
      }
    },
    {
      name: "last_activity_sort",
      label: "",
      options: {
        display: 'excluded',
        filter: false,
        sort: true,
        download: false,
        print: false,
        viewColumns: false,
        searchable: false,
      }
    },
  ];

  // const capitalizeFirstLetter = (text) => {
  //   if (!text) return text;
  //   return text.charAt(0).toUpperCase() + text.slice(1);
  // }

  const data = chatSessions.map((item, index) => ({
    index,
    session: [item._id, item.currentHandler?.type === 'ai' ? 'Нейросеть' : 'Оператор'],
    user: [item.user.name || 'Без имени', item.user.email ? `📩 ${item.user.email}` : item.user.phone ? `📞 ${item.user.phone}` : `Нет контакта`],
    status: [getStatusLabel(item.status), getStatusColor(item.status), item.lastActivity?.split('T')[0]],
    messages: [item.messageCount, item.userMessageCount, item.aiMessageCount, item.operatorMessageCount],
    chat: item,
    last_activity_sort: item.lastActivity,
  }));

  // console.log(chatSessions);

  const options = {
    storageKey: 'chat-table',
    jumpToPage: true,
    rowsPerPageOptions: [10, 25, 50, 100],
    filterType: 'multiselect',
    selectableRows: 'none',
    sortOrder: {
      name: 'last_activity_sort',
      direction: 'desc'
    },
    downloadOptions: {
      filename: `Чаты.${new Date().toISOString().split('T')[0]}.csv`,
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      }
    },
    textLabels: {
      body: {
        noMatch: loading ? (<Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>) : ('Подходящих записей не найдено'),
        toolTip: "Сортировка",
        columnHeaderTooltip: (column) => `Сортировка для ${column.label}`
      },
      pagination: {
        next: "Следующая страница",
        previous: "Предыдущая страница",
        rowsPerPage: "Строк на странице:",
        displayRows: "из",
        jumpToPage: "Перейти на страницу:",
      },
      toolbar: {
        search: "Поиск",
        downloadCsv: "Скачать CSV",
        print: "Печать",
        viewColumns: "Просмотр столбцов",
        filterTable: "Фильтр таблицы",
      },
      filter: {
        all: "Все",
        title: "ФИЛЬТРЫ",
        reset: "СБРОС",
      },
      viewColumns: {
        title: "Показать столбцы",
        titleAria: "Показать/скрыть столбцы таблицы",
      },
      selectedRows: {
        text: "выбрано",
        delete: "Удалить",
        deleteAria: "Удалить выбранные строки",
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      canEdit ? (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ marginRight: '0.5rem' }}>
            <Tooltip title={"Редактировать"}>
              <IconButton
                onClick={() => {
                  const selectedIndices = selectedRows.data.map(row => row.dataIndex);
                  const selectedData = selectedIndices.map(index => data[index]);
                  console.log("Processing custom action for:", selectedData);
                  setSelectedRows([]);
                }}
              ><EditIcon />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ marginRight: '0.5rem' }}>
            <Tooltip title={"Удалить"}>
              <IconButton
                onClick={() => {
                  const selectedIndices = selectedRows.data.map(row => row.dataIndex);
                  const selectedData = selectedIndices.map(index => data[index]);
                  console.log("Processing custom action for:", selectedData);
                  setSelectedRows([]);
                }}
              ><DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>) : (<></>)
    )
  };

  // const options = {
  //   serverSide: true,
  //   onTableChange: (action, tableState) => {
  //     this.xhrRequest('my.api.com/tableData', result => {
  //       this.setState({ data: result });
  //     });
  //   }
  // };

  const appTheme = useTheme();
  const getMuiTheme = () => createTheme(appTheme, {
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          filterPaper: {
            width: '25%',
            minWidth: '20vw',
          },
        },
      },
      MuiGrid: {
        styleOverrides: {
          root: {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
            width: '100%',
            marginLeft: '0',
          },
          item: {
            paddingLeft: '0 !important',
            paddingTop: '1rem !important',
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: '1rem',
            minWidth: '20vw !important',
            padding: '0.5rem !important',
          }
        }
      },
      MUIDataTableViewCol: {
        styleOverrides: {
          root: {
            padding: '1.5rem !important',
          }
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            padding: '0.5rem !important',
          }
        }
      },
    },
  });

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            История чатов пользователей
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Просмотр сессий чатов пользователей с поддержкой и статистика обращений
          </Typography>
        </Box>
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={handleRefresh}
        >Обновить</Button>
      </Box>

      {/* Статистика */}
      {stats && (
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <ChatIcon color="primary" />
                  <Box>
                    <Typography variant="h6">{stats.sessions?.totalSessions || 0}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      Всего сессий
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <SmartToyIcon color="info" />
                  <Box>
                    <Typography variant="h6">{stats.sessions?.activeSessions || 0}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      Активных (Нейросеть)
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <SupportAgentIcon color="warning" />
                  <Box>
                    <Typography variant="h6">{stats.sessions?.waitingOperator + stats.sessions?.withOperator || 0}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      С операторами
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <AssessmentIcon color="success" />
                  <Box>
                    <Typography variant="h6">{stats.connections?.connectedUsers || 0}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      Онлайн сейчас
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {/* Таблица чатов */}
      <ThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"Чаты"}
          data={data}
          columns={columns}
          options={options}
        />
      </ThemeProvider>

      {/* Модальное окно чата */}
      <ChatMessagesModal
        open={chatModalOpen}
        onClose={() => setChatModalOpen(false)}
        session={selectedSession}
        onTakeChat={handleTakeChat}
        onReleaseChat={handleReleaseChat}
        currentAdmin={currentAdmin}
      />

      {/* Уведомления */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AdminChatHistoryPage; 